// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.subwallet",
    name: "SubWallet",
    homepage: "https://www.subwallet.app/",
    image_id: "03f5c08c-fb30-46a0-ca5c-d8fdd7250b00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/subwallet-polkadot-wallet/id1633050285",
        android: "https://play.google.com/store/apps/details?id=app.subwallet.mobile&hl=en_US",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/subwallet-polkadot-wallet/onhogfjeacnfoofkfgppdlbmlmnplgbn",
        firefox: "https://addons.mozilla.org/en-US/firefox/addon/subwallet/",
        safari: null,
        edge: "https://chrome.google.com/webstore/detail/subwallet-polkadot-wallet/onhogfjeacnfoofkfgppdlbmlmnplgbn",
        opera: null,
    },
    rdns: "app.subwallet",
    mobile: {
        native: "subwallet://",
        universal: "https://mobile.subwallet.app/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map